import Form from './Form';

// export types
export type { FormProps } from './Form';
export type { FormInstance } from './hooks/useFormRef';

// export components
export { Form };
export default Form;
